module.exports = __webpack_public_path__ + "static/media/man7.a1955ee2.png";